/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon24Solid = forwardRef('ArrowAUpRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 3a1.5 1.5 0 1 0 0 3h7.879L3.939 17.94a1.5 1.5 0 0 0 2.122 2.12L18 8.122V16a1.5 1.5 0 0 0 3 0V6.5A3.5 3.5 0 0 0 17.5 3H8Z" })));
});
